(function () {
  var frame = 0;
  var attempts = 0;
  var retryTimer;
  var requestController;

  function syncRail() {
    var app = document.querySelector('.yq-app');
    var logo = document.querySelector('.modo-nav__logo');
    var orderButton = document.querySelector('.buy-widget__btn');

    if (!app || !logo || !orderButton) return false;

    var logoRect = logo.getBoundingClientRect();
    var orderRect = orderButton.getBoundingClientRect();
    var left = Math.max(20, logoRect.left);
    var right = Math.max(20, document.documentElement.clientWidth - orderRect.right);

    app.style.setProperty('--modo-track-rail-left', left + 'px');
    app.style.setProperty('--modo-track-rail-right', right + 'px');
    return true;
  }

  function scheduleSync() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(syncRail);
  }

  function retrySync() {
    attempts += 1;
    if (!syncRail() && attempts < 40) {
      retryTimer = window.setTimeout(retrySync, 100);
    }
  }

  function bindStaticForms() {
    document.querySelectorAll('[data-modo-static-track-form]').forEach(function (form) {
      if (form.dataset.modoStaticBound === 'true') return;

      form.dataset.modoStaticBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitTrackingForm(form);
      });
    });
  }

  function getTrackApp(form) {
    return form.closest('[data-modo-static-track]');
  }

  function getEndpoint(app) {
    return (app && app.dataset.modoTrackEndpoint ? app.dataset.modoTrackEndpoint : '').trim();
  }

  function getFieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function setBusy(form, busy) {
    form.querySelectorAll('input, button').forEach(function (el) {
      el.disabled = busy;
    });
    form.dataset.modoTrackBusy = busy ? 'true' : 'false';
  }

  function setStatus(app, message, type) {
    var status = app && app.querySelector('[data-modo-track-status]');
    if (!status) return;

    status.textContent = message || '';
    status.dataset.modoTrackStatusType = type || 'info';
    status.hidden = !message;
  }

  function resetResults(app) {
    var results = app && app.querySelector('[data-modo-track-results]');
    if (!results) return;

    results.hidden = true;
    results.innerHTML = '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatDate(value) {
    if (!value) return '';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  function renderResults(app, payload) {
    var results = app && app.querySelector('[data-modo-track-results]');
    if (!results) return;

    var shipment = payload.shipment || {};
    var events = Array.isArray(payload.events) ? payload.events : [];
    var summaryParts = [
      shipment.trackingNumber ? '<div><span>Tracking number</span><strong>' + escapeHtml(shipment.trackingNumber) + '</strong></div>' : '',
      shipment.lastMileTracking ? '<div><span>Last mile</span><strong>' + escapeHtml(shipment.lastMileTracking) + '</strong></div>' : '',
      shipment.carrier ? '<div><span>Carrier</span><strong>' + escapeHtml(shipment.carrier) + '</strong></div>' : '',
      shipment.status ? '<div><span>Status</span><strong>' + escapeHtml(shipment.status) + '</strong></div>' : '',
      shipment.destinationCountry ? '<div><span>Destination</span><strong>' + escapeHtml(shipment.destinationCountry) + '</strong></div>' : ''
    ].filter(Boolean);

    var eventHtml = events.length
      ? events.map(function (item) {
          return (
            '<li>' +
              '<time>' + escapeHtml(formatDate(item.time)) + (item.timeZone ? ' ' + escapeHtml(item.timeZone) : '') + '</time>' +
              '<p>' + escapeHtml(item.message || item.status || 'Tracking update') + '</p>' +
            '</li>'
          );
        }).join('')
      : '<li><p>No tracking updates are available yet.</p></li>';

    results.innerHTML =
      '<div class="modo-track-summary">' + summaryParts.join('') + '</div>' +
      '<ol class="modo-track-timeline">' + eventHtml + '</ol>';
    results.hidden = false;
  }

  function getPayload(form) {
    var mode = form.dataset.modoTrackMode;
    var orderNumber = getFieldValue(form, 'order_number');
    var trackingNumber = getFieldValue(form, 'tracking_number');
    var emailOrPhone = getFieldValue(form, 'email_or_phone');

    if (mode === 'tracking' && trackingNumber) {
      return {
        mode: 'tracking',
        tracking_number: trackingNumber,
        trade_number: trackingNumber,
        order_number: ''
      };
    }

    if (emailOrPhone && !orderNumber) {
      return {
        mode: 'contact',
        identifier: emailOrPhone,
        email_or_phone: emailOrPhone
      };
    }

    return {
      mode: 'order',
      order_number: orderNumber,
      email_or_phone: emailOrPhone
    };
  }

  async function submitTrackingForm(form) {
    var app = getTrackApp(form);
    var endpoint = getEndpoint(app);
    var payload = getPayload(form);

    resetResults(app);

    if (!endpoint) {
      setStatus(app, 'Tracking service is not configured yet.', 'error');
      return;
    }

    if (!payload.order_number && !payload.trade_number) {
      setStatus(app, 'Please enter your order or tracking number.', 'error');
      return;
    }

    if (requestController) requestController.abort();
    requestController = new AbortController();

    setBusy(form, true);
    setStatus(app, 'Looking up your shipment...', 'loading');

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: requestController.signal
      });
      var data = await response.json().catch(function () {
        return {};
      });

      if (!response.ok || data.ok === false) {
        throw new Error(data.message || 'We could not find tracking information for this order yet.');
      }

      renderResults(app, data);
      setStatus(app, 'Tracking information loaded.', 'success');
    } catch (error) {
      if (error.name !== 'AbortError') {
        setStatus(app, error.message || 'Tracking lookup failed. Please try again later.', 'error');
      }
    } finally {
      setBusy(form, false);
    }
  }

  function start() {
    window.clearTimeout(retryTimer);
    attempts = 0;
    bindStaticForms();
    retrySync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start, { once: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  document.addEventListener('shopify:section:load', start);
})();
